module.exports = __webpack_public_path__ + "static/media/608JamesPBrawleyDrNW_2018-06-12_183.31f50aaa.jpg";